import React from "react";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import {
  getProductDescriptionForProduct,
  getCollInfoForProduct,
  getProductFrontImageForNumber,
} from "../../selectors";
import { bigImageForDetail, imageUrlForList } from "../../utils/products";
import { getTranslateByScope, currentLanguage } from "../../i18n";

import {
  BigImage,
  SmallImage,
  NotMobile,
  Paragraph,
  H3,
  FlexBox,
  SpacingBox,
} from "../../Components";
import AppContext from "../../AppContext";
import { getSearchParam } from "../../utils/routes";

const translate = getTranslateByScope("app.productDetail");
export const ImagesAndDescriptions = withRouter(({ product, ...props }) => (
  <AppContext.Consumer>
    {(context) => {
      const detail = getProductDescriptionForProduct(context, product) || {};
      const collInfo = getCollInfoForProduct(context, product);

      const color = getSearchParam(props, "color");
      const image = getProductFrontImageForNumber(context)(
        product.number,
        color,
      );

      const lang = currentLanguage();
      const collInfoComments = _.uniq(
        _.map(_.get(collInfo, "comments"), (c) => c[lang]),
      );

      const collInfoSymbols = _.uniq(
        _.map(_.get(collInfo, "symbols"), (c) => c),
      );

      const matHeader = (title, val) => (
        <FlexBox marginBottom="xs">
          <SpacingBox marginRight="xs" style={{ minWidth: "150px" }}>
            <b>{translate(title)}</b>
          </SpacingBox>
          {val || translate("missing")}
        </FlexBox>
      );

      const showCollInfo = false;

      return (
        <>
          <div className="row align-items-end">
            <div className="col-12 col-lg-6">
              {image.front && <BigImage src={bigImageForDetail(image.front)} />}
            </div>
            <NotMobile>
              <div className="col-12 col-lg-6">
                {image.back && <SmallImage src={imageUrlForList(image.back)} />}
              </div>
            </NotMobile>
          </div>
          <div className="row">
            <div className="col-12 col-lg-12">
              <FlexBox flexDirection="column">
                <SpacingBox marginTop="md" marginBottom="md">
                  <H3>{translate("materialInformation")}</H3>
                  {matHeader("materialType", detail.MaterialType__c)}
                  {matHeader("mainMaterial", detail.MainMaterial__c)}
                  {matHeader("composition", detail.MaterialComposition__c)}
                  {matHeader("breathability", detail.Breathability__c)}
                  {matHeader("careAdvice", detail.CareAdvice__c)}
                  {matHeader("waterColumn", detail.WaterColumn__c)}
                </SpacingBox>
              </FlexBox>
            </div>
          </div>

          {showCollInfo && (
            <div className="row align-items-end">
              <div className="col-12 col-lg-12">
                <SpacingBox marginTop="md">
                  <H3>{translate("collInfo")}</H3>

                  {collInfo && (
                    <Paragraph>
                      {_.map(collInfoSymbols, (symbol) => (
                        <img
                          width="67px"
                          height="67px"
                          key={JSON.stringify(symbol)}
                          alt={symbol}
                          style={{ paddingRight: "3px" }}
                          src={`https://assets-crm.schoeffel.de/public/images/symbols/${symbol}.png`}
                        />
                      ))}
                    </Paragraph>
                  )}
                  {collInfo &&
                    _.map(collInfoComments, (comment) => (
                      <Paragraph key={comment}>{comment}</Paragraph>
                    ))}
                  {!collInfo && translate("missing")}
                </SpacingBox>
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-12 col-lg-12">
              <FlexBox flexDirection="column">
                <SpacingBox marginTop="md">
                  <H3>{translate("usps")}</H3>
                  <ul>
                    {_.compact([
                      detail.USP1__c,
                      detail.USP2__c,
                      detail.USP3__c,
                      detail.USP4__c,
                      detail.USP5__c,
                      detail.USP6__c,
                    ]).map((usp) => (
                      <li>
                        {usp}
                        <br />
                      </li>
                    ))}
                  </ul>
                </SpacingBox>
              </FlexBox>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-12">
              <FlexBox flexDirection="column">
                <SpacingBox marginTop="md">
                  <H3>{translate("onlineText")}</H3>
                  <Paragraph>
                    {detail.OnlineText__c || translate("missing")}
                  </Paragraph>
                </SpacingBox>
              </FlexBox>
            </div>
          </div>
        </>
      );
    }}
  </AppContext.Consumer>
));
